import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_cell_phone",
  "use": "icon-icon_cell_phone-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-icon_cell_phone\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h18v18H0z\" /><path d=\"M13.5 1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1-.75-.75V2.25a.75.75 0 0 1 .75-.75h9ZM5.25 3v11.979h7.5V3h-7.5Z\" fill=\"#2E5BFD\" fill-rule=\"nonzero\" /><path d=\"M8.25 12h1.5a.75.75 0 1 1 0 1.5h-1.5a.75.75 0 1 1 0-1.5Z\" fill=\"#2E5BFD\" opacity=\".599\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol